import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { withdrawalAPI } from '../api/client';
import { formatDistanceToNow } from 'date-fns';

export const WithdrawalsPage = () => {
  const navigate = useNavigate();
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const fetchWithdrawals = async () => {
    try {
      const response = await withdrawalAPI.getHistory();
      setWithdrawals(response.data.data);
    } catch (err) {
      console.error('Error fetching withdrawals:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-gray-400">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800">
      <nav className="bg-slate-800 border-b border-slate-700 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded flex items-center justify-center text-lg font-bold">₹</div>
            <h1 className="text-2xl font-bold text-white">PaySolutions</h1>
          </div>
          <button
            onClick={() => navigate('/dashboard')}
            className="text-gray-400 hover:text-yellow-400 transition"
          >
            Back
          </button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto py-12 px-4">
        <h2 className="text-2xl font-bold text-white mb-6">Withdrawal History</h2>

        {withdrawals.length === 0 ? (
          <div className="bg-slate-800 rounded-xl shadow-lg p-8 text-center border border-slate-700">
            <p className="text-gray-400">No withdrawals yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {withdrawals.map((wd) => (
              <div key={wd.id} className="bg-slate-800 rounded-xl shadow-lg p-6 border border-slate-700 hover:border-slate-600 transition">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-sm text-gray-400 mb-1">Amount Requested</p>
                    <p className="text-3xl font-bold text-white">₹{wd.gross_amount}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1">You Will Receive</p>
                    <p className="text-3xl font-bold text-emerald-400">₹{wd.user_receives}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1">Bank</p>
                    <p className="font-semibold text-gray-300">{wd.bank_name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1">Status</p>
                    <p className={`inline-block px-3 py-1 rounded-lg font-semibold text-sm ${
                      wd.status === 'success' ? 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30' :
                      wd.status === 'processing' || wd.status === 'pending' ? 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30' :
                      'bg-red-500/20 text-red-300 border border-red-500/30'
                    }`}>
                      {wd.status}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1">Account</p>
                    <p className="font-mono text-sm text-gray-300">...{wd.account_number.slice(-4)}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1">Estimated Time</p>
                    <p className="font-semibold text-gray-300">{wd.estimated_time_hours} hours</p>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-sm text-gray-400 mb-1">Date</p>
                    <p className="text-gray-300">
                      {formatDistanceToNow(new Date(wd.created_at), { addSuffix: true })}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
